import { mapGetters } from 'vuex'

/* DICIONARY
  545697e894825c828956e7ce887791a4 => Cadastro de usuários
  0053d6310971f7162b1fbcba81647685 => Enviar convite usuário
  72cc27f26644651e5dbf72c4f9a22f35 => Listar Usuários
  11d0632099c633b1dd73b9bac676a621 => Alterar Usuários
  f901d8efe84b23cb63ff741ba3b76943 => Excluir Usuários
  729fc37cb039db91d8dd6f6960cd8c0d => Conceder Permissões

  2e39d305f43aa421df0c1c6ff28afa66 => Cadastro de clientes (clientes dos clientes da SS Parisi)
  9c4ed0d746c5a7913cab38a938780acf => Criar cliente
  5bc919ca057f99025eabfda5818b9741 => Alterar cliente
  1f152b722d64ba573cd756fe5757ec80 => Listar clientes
  b0151a967f25aac481c7ea315366e9f1 => Excluir clientes
  2f73831d056ff52bb0028d0a50f791e9 => Associar produtos ao cliente

  80a7c7bb342012d2f4f46148049cb972 => Cadastro de empresas (clientes diretos da SS Parisi)
  fee433134b6bab184b3f25e87da62aa4 => Listar empresas
  8a2fd41ee4b3be69484fb1114cc95341 => Alterar empresas
  3ff404bca7f1307a56b8976209119d4d => Ativar/inativar empresa
  3e3fc7d1f943ad6bfe6c6b056873ce8e => Associar Produto a empresa
  a6a5dd0f28c2447842c5b000f9a54cbf => Remover Produto na empresa
*/

/* Constante se refere ao produto em questão, nesse caso Portal */
const PRODUCT = 'd300660e4320d8d5c8ecb48035b67815'

export const permissions = {
  data () {
    return {
      loggedUser: {}
    }
  },

  methods: {
    ...mapGetters(['getLoggedUser', 'getPermissions', 'getCompany']),

    /**
     * Verificação das permissões
     * @param  {String} companyKey public_key do cliente que se quer alterar algo.
     * @param  {String} actionKey public_key da ação que se deseja realizar (alterar usuário 11d0632099c633b1dd73b9bac676a621)
     * @param  {String} actionText Texto para ser exibido no toast
     * @return {boolean} boleano informando se o usuário possui ou não permissão, no caso negativo o próprio mixin informa.
     */
    checkPermissions (companyKey, actionKey, actionText = '') {
      return this.checkPermissionInsideCompany(this.getCompany().public_key, actionKey).then(resp => {
        if (resp === false) {
          if (actionText !== '') { this.show_toast('info', 'Sem Permissão', `Você não tem permissão para ${actionText}`) }
          return Promise.resolve(false)
        } else { return Promise.resolve(true) }
      })
      /* return new Promise((resolve, reject) => {
        if (companyKey) {
          this.checkPermissionInsideCompany(companyKey, actionKey).then((resp) => {
            if (resp === false) {
              if (actionText!== '') this.show_toast('info', 'Sem Permissão', `Você não tem permissão para ${actionText}`)
              resolve(false)
            } else { resolve(true) }
          })
        } else {
          this.checkUserLoosePermissions(actionKey).then((rsp) => {
            if (rsp === false) {
              if (actionText!== '') this.show_toast('info', 'Sem Permissão', `Você não tem permissão para ${actionText}`)
              resolve(false)
            } else { resolve(true) }
          })
        }
      }) */
    },

    checkUserLoosePermissions (actionKey) {
      return new Promise((resolve, reject) => {
        let permissions = this.getPermissions()
        let count = 0

        /* testa se o user é root */
        if (permissions.length === 0 && this.rootUser()) resolve(true)

        permissions.forEach((comp) => {
          comp.products.forEach((prods) => {
            if (prods) {
              prods.functionalities.forEach((access) => {
                if (access === []) resolve(true)
                if (access === actionKey) { count = count + 1 }
              })
            } else {
              resolve(false)
            }
          })
        })
        if (count === permissions.length) resolve(false)
        else { resolve(true) }
      })
    },

    checkPermissionInsideCompany (companyKey, actionKey) {
      return new Promise((resolve, reject) => {
        let permissions = this.getPermissions()

        /* testa se o user é root */
        if (this.rootUser()) resolve(true)

        let company = permissions.find(cp => cp.public_key === companyKey)
        if (!company) { resolve(false) }
        let prod = company.products.find(pr => pr.public_key === PRODUCT)
        let isPermited = prod.functionalities.find(fn => fn === actionKey)

        if (isPermited) resolve(false)
        else { resolve(true) }
      })
    },

    rootUser () {
      if (this.loggedUser.email === 'dev.ssparisi@gmail.com') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.loggedUser = this.getLoggedUser()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permissions.js